import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { AddressInput } from '../../components/molecules/AddressInput';
import { MultiStepLayout } from '../../components/templates/MultiStepLayout';
import { Address } from '../../types/tenantScreening';

export interface AddressStepProps {
  address: Partial<Address>;
  onAddressChange: (address: Partial<Address>) => void;
  onNext: () => void;
  onBack: () => void;
  isLoading?: boolean;
}

export const AddressStep: React.FC<AddressStepProps> = ({
  address,
  onAddressChange,
  onNext,
  onBack,
  isLoading = false,
}) => {
  const [localAddress, setLocalAddress] = useState<string>(
    address.fullAddress || ''
  );
  const [isValid, setIsValid] = useState<boolean>(false);

  const handleAddressChange = (value: string) => {
    setLocalAddress(value);

    onAddressChange({
      ...address,
      fullAddress: value,
      street: value.split(',')[0]?.trim() || '',
      city: value.split(',')[1]?.trim() || '',
      state: value.split(',')[2]?.trim() || '',
      zipCode: value.split(',')[3]?.trim() || '',
    });
  };

  const handleValidationChange = (valid: boolean) => {
    setIsValid(valid);
  };

  const handleNext = () => {
    if (isValid && !isLoading) {
      onNext();
    }
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' && isValid) {
      handleNext();
    }
  };

  const navigate = useNavigate();

  const handleHomeClick = () => {
    navigate('/');
  };

  const handleExitClick = () => {
    navigate('/');
  };

  return (
    <MultiStepLayout
      currentStep={1}
      total={7}
      currentSubStepPercentage={100}
      onHomeClick={handleHomeClick}
      onExitClick={handleExitClick}
      onBack={onBack}
      onNext={handleNext}
      backDisabled={true}
      nextDisabled={!isValid || isLoading}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
          width: '100%',
          maxWidth: { xs: '100%', sm: 600 },
          mx: 'auto',
          px: { xs: 2, sm: 0 },
        }}
      >
        <Box sx={{ textAlign: 'center', mb: 2 }}>
          <Typography
            variant='h5'
            sx={{
              fontSize: '28px',
              fontWeight: 600,
              color: '#111827',
              mb: 1,
            }}
          >
            Where's your place located?
          </Typography>
        </Box>

        <AddressInput
          value={localAddress}
          onChange={handleAddressChange}
          onValidationChange={handleValidationChange}
          onKeyPress={handleKeyPress}
          placeholder='Enter your address'
          autoFocus
          disabled={isLoading}
        />
      </Box>
    </MultiStepLayout>
  );
};

export default AddressStep;
